module.exports = __webpack_public_path__ + "img/zc-01.0f8ef81f.svg";